module.exports = __webpack_public_path__ + "img/banner-img.a15af741.jpg";